<template>
  <v-btn @click="back" icon class="back-button">
    <v-icon color="rgba(51, 51, 51, 1)" size="34">
      {{ mdiChevronLeft }}
    </v-icon>
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { mapGetters } from 'vuex'
import { mdiChevronLeft } from '@mdi/js'

import { getPath } from '@/utils/general-utils'

@Options({
   props: {
    customBack: {
      type: Boolean,
      default: false,
    },
    computed: mapGetters(['originalHistoryCount']),
  },
})
export default class BackButton extends Vue {

  mdiChevronLeft = mdiChevronLeft
  originalHistoryCount!: number
  customBack!: boolean

  back(): void {
    if (this.customBack) {
      this.$emit('back')
    } else {
      // TODO: window.history.length seems to max out at 50
      if (window.history.length - this.originalHistoryCount === 0) {
        // TODO: confirm no history action
        this.$router.push(getPath('/'))
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss">
.back-button {
  width: 24px !important;
  height: 24px !important;
  z-index: $back-button-z-index;

  &__image, .v-image__image--cover {
     background-size: 24px;
  }
}

</style>